import type { OfficeJobResponse } from "./types/office-job-response";

import { marketingApiGet } from "./marketing-api-get";

type GetOfficeJobsOptions = {
  throwOnError?: boolean;
};

async function getOfficeJobs(
  officeId: string | number,
  options: GetOfficeJobsOptions = {},
): Promise<OfficeJobResponse[]> {
  return marketingApiGet<OfficeJobResponse[]>({
    emptyValue: [],
    logContext: { officeId },
    logMessage: "Failed to fetch office jobs from hi-marketing-api",
    path: `/api/v1/offices/${officeId}/jobs`,
    throwOnError: options.throwOnError,
  });
}

export { getOfficeJobs };
